import * as rrule from 'rrule'
import { toZonedTime } from 'date-fns-tz'
import {
  IntervalInTimeZone,
  IntervalISOString,
  ISODateTimeString,
  RECURRENCE_FOREVER_DATE,
  RecurrenceException,
} from './types'
import {
  forceTzToMinute,
  forceUtcFromLocalDateParts,
} from './forceTz'

const RRule =
  // @ts-expect-error RRule can come from different places
  rrule.RRule ?? (rrule as never).default?.RRule
const RRuleSet =
  // @ts-expect-error RRule can come from different places
  rrule.RRuleSet ?? (rrule as never).default?.RRuleSet

export function isRecurForever(
  date: Date | ISODateTimeString | number | null | undefined
) {
  if (typeof date === 'string') {
    date = new Date(date)
  }
  return date?.valueOf() === RECURRENCE_FOREVER_DATE
}

export function recurrenceDatesWithinInterval(
  range: IntervalInTimeZone,
  recurrencePattern: string,
  recurrenceExceptions: RecurrenceException[],
  interval: IntervalISOString
) {
  const options = RRule.parseString(recurrencePattern)
  const zonedStart = toZonedTime(range.start, range.timeZone)
  const dtstart = forceUtcFromLocalDateParts(zonedStart)
  const ruleSet = new RRuleSet()
  ruleSet.rrule(
    new RRule({
      ...options,
      dtstart,
      until: new Date(range.end),
    })
  )
  for (const exception of recurrenceExceptions) {
    const exstart = forceUtcFromLocalDateParts(
      toZonedTime(exception.start, range.timeZone)
    )
    ruleSet.exrule(
      new RRule({
        freq: RRule.DAILY,
        count: 1,
        dtstart: exstart,
      })
    )
  }
  return ruleSet
    .between(
      new Date(interval.start),
      new Date(interval.end),
      true
    )
    .map((date) => forceTzToMinute(range.timeZone, date))
}
